import { Enrollment, HttpError } from '@rd/types';
import { toObject } from '@rd/utils/array.utils';
import {
  EnrollmentActions,
  EnrollmentActionTypes,
} from '../actions/enrollment.actions';

export interface EnrollmentState {
  enrollments: {
    [key: string]: Partial<Enrollment>;
  };
  error: HttpError | null;
  loading: boolean;
}

const initialState: EnrollmentState = {
  enrollments: {},
  error: null,
  loading: false,
};

export function enrollmentReducer(
  state: EnrollmentState = initialState,
  action: EnrollmentActions,
): EnrollmentState {
  switch (action.type) {
    case EnrollmentActionTypes.LOAD_ENROLLMENTS:
      return {
        ...state,
        enrollments: {},
        error: null,
        loading: true,
      };

    case EnrollmentActionTypes.LOAD_ENROLLMENTS_SUCCESS:
      return {
        ...state,
        enrollments: toObject(action.payload, 'id'),
        error: null,
        loading: false,
      };

    case EnrollmentActionTypes.LOAD_ENROLLMENTS_FAIL:
      return {
        ...state,
        enrollments: {},
        error: action.payload,
        loading: false,
      };
  }

  return state;
}
